import { useEffect, useLayoutEffect } from 'react'

import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import { maskDDD, maskPhone, ONLYLETTERS } from 'services/utils'
import { toast } from 'react-toastify'
import Loading from 'Components/Loading'
import SYSTEM_MESSAGES from 'services/Messages'
import config from '../../../static/Inicio'
import { usePatient } from 'Components/usePatientContext'
import { Formik, useFormikContext } from 'formik'
import initialState from './config'
import { schema } from './schema'
import DateComponent from 'Components/DateComponent'
import InputCpf from 'Components/InputCpf'
import InputTextField from 'Components/InputTextField'
import InputSelect from 'Components/InputSelect'

const name = process.env.REACT_APP_BUSINESS_NAME

const Wrapper = () => {

    const { patient, loading } = usePatient()

    const { USER_NOT_FOUND } = SYSTEM_MESSAGES

    const { 
        isValid,
        isSubmitting,
        touched,
        errors,
        values, 
        setFieldValue, 
        handleChange, 
        handleBlur,
        handleSubmit 
    } = useFormikContext()

    

    const handleMask = (e, mask) => { 
        
        const input = e.target
       
        if (mask) {
            input.value = input.value.replace(mask, '')
        }
    }

    useEffect(() => {

        setFieldValue('cpfPaciente', patient.cpfPaciente)
    
        if (patient?.nomePessoa)     setFieldValue('nomePaciente'  , patient.nomePessoa)
        if (patient?.sexo)           setFieldValue('sexoPaciente'  , patient.sexo)
        
    }, [setFieldValue, patient])

    useLayoutEffect( () => {
        
        toast.success(USER_NOT_FOUND)

        return () => {
            toast.dismiss()
        }

    }, [USER_NOT_FOUND])

    // cpfPaciente 
    // dataNascimentoPaciente
    // dddCelularPaciente
    // emailPaciente
    // nomePaciente
    // numeroCelularPaciente
    // sexoPaciente

    return (<Box
        component="form"
        noValidate
        autoComplete="off"
    >   
        <Typography variant="h3" 
            spacing={4} 
            component="h3"
            mt={2} 
        >{config.title} {name}</Typography>
        <Grid container spacing={2} py={2}>
            <Grid item md={12} xs={12} mb={2} >
                <InputCpf 
                    id="cpfPaciente"
                    name="cpfPaciente"
                    
                    disabled={true}
                    onChange={handleChange}
                    value={values.cpfPaciente} 
                    placeholder="Digite o seu CPF"
                        fullWidth
                        helperText={
                            values.cpfPaciente.length === 0 ? 
                            <Typography variant='subtitle1' component='span'>Digite seu CPF para iniciarmos o agendamento</Typography> 
                            : ''
                        } 
                />
                   
                
            </Grid>  
            <Grid item md={12} xs={12} >
                <InputTextField
                   
                    id="nomePaciente"
                    name="nomePaciente"
                    label="Nome completo"
                    placeholder="Digite o seu nome completo"
                    fullWidth
                    onChange={ e => {
                        handleMask(e, ONLYLETTERS)
                        handleChange(e)
                    }}
                    onBlur={handleBlur}
                    value={values.nomePaciente}
                    errors={errors}
                    touched={touched}
                    
                />
                
            </Grid>  
            <Grid item md={6} xs={12} >
                <InputSelect 
                    options={[
                        { value: 'M', title: 'Masculino' },
                        { value: 'F', title: 'Feminino' }
                    ]} 
                    placeholder={'Selecione o gênero'}
                    id="sexoPaciente"
                    name="sexoPaciente"
                    label="Gênero"
                  
                    onChange={handleChange}
                    onBlur={handleBlur}
                    fullWidth
                    value={values.sexoPaciente}
                    error={touched.sexoPaciente && Boolean(errors.sexoPaciente)}
                >
                </InputSelect> 
            </Grid>  
            <Grid item md={6} xs={12} >
                <DateComponent
                    defaultValue={patient?.dataNascimento}
                    id="dataNascimento"
                    name="dataNascimento"
                    label="Data de nascimento"
                    placeholder={'dd/mm/aaaa'}
                    format="dd/MM/yyyy" 
                    value={values?.dataNascimento}
                    onChange={(newValue) => setFieldValue('dataNascimento', newValue, true)}
                    touched={touched} 
                    error={touched?.dataNascimento && Boolean(errors?.dataNascimento)}
                    slotProps={{
                        textField: {
                            helperText: touched.dataNascimento && errors.dataNascimento,
                            onBlur: handleBlur
                            
                        }
                    }}
                
                />
                
                
            </Grid>  
            <Grid item md={6} xs={12} >
                <InputTextField
                    id="emailPaciente"
                    name="emailPaciente"
                    label="Email"
                    placeholder="Digite seu email"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    fullWidth
                    value={values.emailPaciente}
                    errors={errors}
                    touched={touched}
                />
            </Grid> 

            <Grid item md={1} xs={3} >
                <InputTextField
                    id="dddCelularPaciente"
                    name="dddCelularPaciente"
                    label="DDD"
                    placeholder="Ex: 11"
                    onChange={ e => {
                        maskDDD(e)
                        handleChange(e)
                    }}
                    onBlur={handleBlur}
                    max={2}
                    value={values.dddCelularPaciente}
                    fullWidth
                    errors={errors}
                    touched={touched}
                />
            </Grid>

            <Grid item md={5} xs={9} >
                <InputTextField
                    id="numeroCelularPaciente"
                    name="numeroCelularPaciente"
                    label="Celular"
                    placeholder="Digite o número do seu celular"
                    onChange={e => {
                        maskPhone(e)
                        handleChange(e)
                    }}
                    value={values.numeroCelularPaciente}
                    fullWidth
                    onBlur={handleBlur}
                    errors={errors}
                    touched={touched}
                />
                
            </Grid>
            <Grid item md={12} xs={12} >
                <Button 
                    disabled={!isValid || isSubmitting} 
                    spacing={2} 
                    variant="contained" 
                    onClick={handleSubmit} 
                    fullWidth
                    sx={{
                        bgcolor: process.env.REACT_APP_BUTTON_STYLE_BG, 
                        color: '#fff', 
                        '&:hover': {
                            bgcolor: process.env.REACT_APP_BUTTON_STYLE_HOVER
                        },
                        height: 60, 
                    }}
                    size={'large'}
                >Iniciar Agendamento</Button>
            </Grid>
            {loading && <Loading />}
        </Grid>
    </Box>)    
    
}

const Cadastro = () => {

    const { creactUser } = usePatient()

    const handleSubmit = (request) => {
        creactUser(request)
    }

    return <Formik 
        initialValues={initialState}
        validationSchema={schema}
        enableReinitialize={true}
        onSubmit={handleSubmit}
    >
        <Wrapper />
    </Formik>
}

export default Cadastro